/**
 * @file Google provided script to play videos in an inline iFrame
 */
//This code loads the IFrame Player API code asynchronously.
var youtubeScriptId = 'youtube-api';
var youtubeScript = document.getElementById(youtubeScriptId);

if (youtubeScript === null) {
  var tag = document.createElement('script');
  var firstScript = document.getElementsByTagName('script')[0];
  tag.id = youtubeScriptId;
  tag.src = 'https://www.youtube.com/iframe_api';
  firstScript.parentNode.insertBefore(tag, firstScript);
}

var player;
function onYouTubeIframeAPIReady() {
    player = new YT.Player('player', {
        height: '390',
        width: '640',
        videoId: 'M7lc1UVf-VE',
        playerVars: {
            'playsinline': 1
        }
    });
}
function showVideoTitle(videoId) {
    if (videoId != '') {
        document.getElementById('VideoTitle').style.display = "block";
        player.loadVideoById(videoId);
        player.playVideo();
    }
}
function stopHideVideo() {
    player.stopVideo();
    document.getElementById('VideoTitle').style.display = "none";
}